export default {
  underline: {
    '&:before': {
      borderBottom: 0,
    },
  },
};
